<ng-template #registerModal let-modal>
  <div class="mt-5 px-5 d-flex align-items-center">
    <h5 class="font-trueno-bold font-28 fw-bold" id="register-modal" [innerHTML]="'REGISTRATION.MODAL_REGISTER.TITLE' | translate">
    </h5>
    <span class="font-12 lightGray2 font-trueno-light fw-bold ms-2">{{(showInfosForm ? 4 : page) + '/' + 4}}</span>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <div class="px-5 pb-2 pt-4" *ngIf="registerError">
    <div class="alert alert-danger" [innerHTML]="'COMMON.ERROR.GO_TO_SUPPORT' | translate">
    </div>
  </div>

  <div class="br-16 register_form">
    <!------------------   PARTIE BASIC INFOS   -------------------------------------------------------------------------->
    <div class="w-100 px-5 pb-5 pt-2" *ngIf="page == 1">
      <form class="d-flex flex-column gap-8" [formGroup]="accountForm" (ngSubmit)="submitForm()"
        id="registerForm_page1" *ngIf="accountForm">

        <!--   lastname   -->
        <div class="position-relative">
          <mat-form-field class="w-100">
            <mat-label class="subtitle_1 text-black">{{ "PROFILE.LASTNAME" | translate }}</mat-label>
            <input matInput type="text" formControlName="lastname" (keyup)="checkLatin('lastname',$event)"
              [ngClass]="{'is-invalid' : isAccountFormSubmit && accountForm.controls.lastname.errors}">
            <mat-error *ngIf="isAccountFormSubmit && accountForm.controls.lastname.errors">
              {{ "COMMON.IS_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
          <div *ngIf="errors.lastname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
            {{errors.lastname}}
          </div>
          <div class="text-success d-flex align-items-center font-12 absolute-block-centered"
            *ngIf="!accountForm.controls.lastname.errors">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <!--   firstname   -->
        <div class="position-relative">
          <mat-form-field class="w-100">
            <mat-label class="subtitle_1 text-black">{{ "PROFILE.FIRSTNAME" | translate }}</mat-label>
            <input matInput type="text" formControlName="firstname" (keyup)="checkLatin('firstname',$event)"
              [ngClass]="{'is-invalid' : isAccountFormSubmit && accountForm.controls.firstname.errors}">
            <mat-error
              *ngIf="isAccountFormSubmit && accountForm.controls.firstname.errors">
              {{ "COMMON.IS_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
          <div *ngIf="errors.firstname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
            {{errors.firstname}}
          </div>
          <div class="text-success d-flex align-items-center font-12 absolute-block-centered"
            *ngIf="!accountForm.controls.firstname.errors">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <!--   phone   -->
        <div class="position-relative py-3">
          <span class="label subtitle_1 form-label-color text-black rescale">{{ "PROFILE.PHONE" | translate }} *</span>
          <ngx-intl-tel-input class="ngx-intl-tel_mat-form-style"
            [ngClass]="{ 'is-invalid': isAccountFormSubmit && accountForm.controls.phone.errors }"
            [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [separateDialCode]="true"
            [maxLength]="'20'" [phoneValidation]="true" formControlName="phone"></ngx-intl-tel-input>

          <div class="minitext_2 position-absolute red-error"
            *ngIf="isAccountFormSubmit && accountForm.controls.phone.errors">
            {{ "COMMON.IS_REQUIRED" | translate }}
          </div>
          <div class="absolute-block-centered text-success d-flex align-items-center minitext_2"
            *ngIf="!accountForm.controls.phone.errors">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <button type="submit" id="register_go_to_page_2" class="btn btn-primary w-100 fw-bold py-2 mt-4" checkFormError>
          <span class="material-icons-outlined v-middle font-20 me-1">file_download_done</span>
          {{ 'COMMON.NEXT' | translate }}
        </button>
      </form>
    </div>

    <!------------------   PARTIE USER INFOS   -------------------------------------------------------------------------->
    <div class="px-5 pb-5 pt-2 w-100" *ngIf="page == 2">
      <form [formGroup]="userForm" (ngSubmit)="submitForm()" id="registerForm_page2">

        <!-- birthdate -->
        <div class="label mediumGray font-14">{{ "PROFILE.BIRTHDATE" | translate }}</div>
        <app-birthdate-divided [birthdate]="userForm.value.birthdate" [type]="'birthdate'" [disableCentering]="true" [panelClass]="'mat-select_under-input'"
          [ngClass]="{'form_invalid': !isBirthdayCorrect || (isUserFormSubmit && userForm.controls.birthdate.invalid)}"
          (newBirthdate)="setBirthdate($event)"></app-birthdate-divided>
        <div class="red-error minitext_2 mt-2"
          *ngIf="!isBirthdayCorrect || (isUserFormSubmit && userForm.controls.birthdate.invalid)">
          {{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}
        </div>
        <p class="font-12 lightGray2 mt-2 pb-3" [innerHTML]="'REGISTRATION.MODAL_REGISTER.SUB.BIRTHDATE' | translate"></p>

        <!-- nationality -->
        <div class="mt-4">
          <div class="position-relative mb-1">
            <mat-select-country class="pb-0 w-100" label="{{ 'PROFILE.NATIONALITY' | translate }}"
              [value]="userForm.value.nationality"
              (onCountrySelected)="onCountrySelected($event)" required
              [formControl]="userForm.controls.nationality"
              [ngClass]="{ 'is-invalid': isUserFormSubmit && userForm.controls.nationality.errors }"
              [countries]="predefinedCountries">
            </mat-select-country>
            <span class="material-icons-outlined position-absolute country_arrow">arrow_drop_down</span>
          </div>
          <div *ngIf="isUserFormSubmit && userForm.controls?.nationality.errors?.required"
            class="red-error minitext_2">
            {{ "COMMON.IS_REQUIRED" | translate }}
          </div>
          <p class="font-12 lightGray2" [innerHTML]="'REGISTRATION.MODAL_REGISTER.SUB.NATIONALITY' | translate"></p>
        </div>

        <!-- gender -->
        <div class="mt-4">
           <span class="label mediumGray font-14">
            {{ "PROFILE.GENDER" | translate }} *
          </span>

          <div class="d-flex justify-content-start mt-2 gap-24">
            <label class="d-flex gap-8 pointer">
              {{ "COMMON.USER.GENDER_MALE" | translate }}
              <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="male" [ngClass]="{'border-error': isUserFormSubmit && userForm.controls?.gender.invalid}">
            </label>

            <label class="d-flex gap-8 pointer">
              {{ "COMMON.USER.GENDER_FEMALE" | translate }}
              <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="female" [ngClass]="{'border-error': isUserFormSubmit && userForm.controls?.gender.invalid}">
            </label>
          </div>
          <div class="red-error minitext_2" *ngIf="isUserFormSubmit && userForm.controls?.gender.invalid">
            {{ 'COMMON.IS_REQUIRED' | translate }}
          </div>
          <p class="font-12 lightGray2" [innerHTML]="'REGISTRATION.MODAL_REGISTER.SUB.GENDER' | translate"></p>
        </div>

        <!-- duration  -->
        <div class="mt-4" *ngIf="userForm.controls.stayDuration">
          <mat-form-field class="w-100 label_wrap" (focusin)="changeDisplayUnit($event)" (focusout)="changeDisplayUnit($event)">
            <mat-label [innerHTML]="'PROFILE.STAY_DURATION' | translate" class="subtitle_1 text-wrap"></mat-label>
            <input matInput type="number" min="1" max="200" [formControl]="userForm.controls.stayDuration">
            <div class="input_unit" *ngIf="displayUnit || (!displayUnit && userForm.controls.stayDuration.value)">
              <span class="invisible">{{ userForm.controls.stayDuration.value }}</span>
              <span class="ms-1">
                {{ (userForm.controls.stayDuration.value <= 1 ? 'COMMON.MONTH' : 'COMMON.MONTHS')| translate }}
              </span>
            </div>
            <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
          </mat-form-field>
        </div>

        <div class="d-flex gap-8 mt-4">
          <button type="button" class="btn btn-black-border border-2 txt-darkGray" (click)="prevPage()">
            <span class="material-icons va-sub">chevron_left</span>
          </button>
          <button type="submit" id="register_go_to_page_3" class="btn btn-primary flex-grow-1 fw-bold py-2 " checkFormError>
            <span class="material-icons-outlined v-middle font-20 me-1">file_download_done</span>
            {{'COMMON.NEXT' | translate }}
          </button>
        </div>

      </form>
    </div>

    <!------------------   PARTIE SCHOOL -------------------------------------------------------------------------->
    <div class="px-5 pb-5 pt-2 w-100" *ngIf="page == 3 && page !== maxPage">
      <form class="d-flex flex-column gap-8" [formGroup]="schoolForm" (ngSubmit)="submitForm()" id="registerForm_schoolPage">

        <!--   FACULTY     -->
        <mat-form-field *ngIf="school.faculties && school.faculties.length > 0">
          <mat-label class="subtitle_1 text-black">
            {{ (slug == 'livinfrance' ? 'COMMON.USER.FACULTY_LIVINFRANCE' : 'COMMON.USER.FACULTY') | translate }}
          </mat-label>
          <mat-select [formControl]="schoolForm.controls.faculty_id" required>
            <mat-option value="{{faculty.id}}" *ngFor="let faculty of school.faculties">{{ faculty.name }}</mat-option>
          </mat-select>
          <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
        </mat-form-field>

        <!--   FORMATIONS     -->
        <mat-form-field>
          <mat-label class="subtitle_1 text-black">{{ "Formation" | translate }}</mat-label>
          <mat-select [formControl]="schoolForm.controls.formation_id" required>
            <mat-option value="{{formation.id}}" *ngFor="let formation of formations">{{ formation.name }}</mat-option>
          </mat-select>
          <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
        </mat-form-field>

        <!--   SITUATION     -->
        <mat-form-field>
          <mat-label class="subtitle_1 text-black">{{ "COMMON.USER.MOBILITY_TYPE" | translate }}</mat-label>
          <mat-select [formControl]="schoolForm.controls.situation" required>
            <mat-option value="exchange">{{ "REGISTRATION.SITUATION.EXCHANGE" | translate }}</mat-option>
            <mat-option value="freemover">{{ "REGISTRATION.SITUATION.FREEMOVER" | translate }}</mat-option>
          </mat-select>
          <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
        </mat-form-field>

        <!--   RGPD CONSENT     -->
        <div class="custom-control custom-checkbox mt-2" *ngIf="schoolForm.controls.shareData">
          <input type="checkbox" class="custom-control-input" id="schoolConsent" formControlName="shareData"
            [ngClass]="{ 'is-invalid': isSchoolFormSubmit && schoolForm.controls.shareData.errors }">
          <label for="schoolConsent" class="mb-0 custom-control-label font-12"
            [innerHTML]=" 'USER.CONSENT.SCHOOL_SHARE.ACCEPT' | translate: {value: school.name} "></label>
          <div *ngIf="school && isSchoolFormSubmit && schoolForm.controls.shareData.errors && schoolForm.controls.shareData.errors.required" class="invalid-feedback">
            {{ "USER.CONSENT.SCHOOL_SHARE.ERROR" | translate: {value: school.name} }}
          </div>
        </div>

        <div class="d-flex gap-8 mt-4">
          <button type="button" class="btn btn-black-border border-2 disabled txt-darkGray" (click)="prevPage()">
            <span class="material-icons va-sub">chevron_left</span>
          </button>
          <button type="submit" id="register_go_to_lastpage" class="btn btn-primary flex-grow-1 fw-bold py-2 " checkFormError>
            <span class="material-icons-outlined v-middle font-20 me-1">file_download_done</span>
            {{'COMMON.NEXT' | translate }}
          </button>
        </div>

      </form>
    </div>

    <!------------------   PARTIE CREATE ACCOUNT -------------------------------------------------------------------------->
    <div class="px-5 pb-5 pt-2 w-100" *ngIf="page == maxPage && !showInfosForm" openCookie>
      <form [formGroup]="credForm" (ngSubmit)="submitForm()" id="registerForm_lastPage">
        <!--   email   -->
        <div class="position-relative mb-2">
          <mat-form-field class="w-100">
            <mat-label class="subtitle_1 text-black">{{ "PROFILE.EMAIL" | translate }}</mat-label>
            <input matInput type="email" formControlName="email"
              [ngClass]="{'is-invalid' : isCredFormSubmit && credForm.controls.email.errors}">
            <mat-error>
              <span *ngIf="credForm.controls.email.errors?.required">{{ "COMMON.IS_REQUIRED" | translate }} </span>
              <span *ngIf="credForm.controls.email.errors?.email">{{ "COMMON.WRONG_FORMAT" | translate }}</span>
              <span *ngIf="credForm.controls.email.errors?.invalidDomain">
                {{ "COMMON.WRONG_FORMAT" | translate }}
              </span>
              <span *ngIf="credForm.controls.email.errors?.taken">
                {{ 'ERROR.DUPLICATE_EMAIL' | translate }}
                <span class="ms-1 lightGray2 pointer" (click)="goToLogin()">
                  {{ 'COMMON.LOGIN' | translate }}
                  <span class="material-icons va-sub font-14">chevron_right</span>
                </span>
              </span>
            </mat-error>
          </mat-form-field>
          <div class="absolute-block-centered text-success d-flex align-items-center font-12"
            *ngIf="!credForm.controls.email.errors && credForm.status !== 'PENDING'">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
          <div class="absolute-block-centered" *ngIf="credForm.status === 'PENDING'">
            <span class="spinner-border spinner-border-sm me-1 v-middle text-black"></span>
          </div>
        </div>


        <!--   password   -->
        <div class="position-relative">
          <mat-form-field class="w-100">
            <mat-label class="subtitle_1 text-black">{{ "COMMON.USER.PASSWORD" | translate }}</mat-label>
            <input matInput type="password" formControlName="password"
              [ngClass]="{'is-invalid' : isCredFormSubmit && credForm.controls.password.errors}">
            <mat-error *ngIf="isCredFormSubmit && credForm.controls.password.errors">
              <span *ngIf="credForm.controls.password.errors.required">{{ "COMMON.IS_REQUIRED" | translate }}</span>
              <span *ngIf="credForm.controls.password.errors['minlength']">
                {{ "REGISTRATION.PASSWORD_LENGTH_ERROR" | translate }}
              </span>
            </mat-error>
          </mat-form-field>
          <div class="absolute-block-centered text-success d-flex align-items-center font-12"
            *ngIf="!credForm.controls.password.errors">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <div class="custom-control custom-checkbox mt-2 " *ngIf="credForm.controls.consent">
          <div class="d-flex gap-8">
            <input type="checkbox" class="custom-control-input" id="rgpdConsent" formControlName="consent"
              [ngClass]="{ 'is-invalid': isCredFormSubmit && credForm.controls.consent.errors }">
            <label for="rgpdConsent" class="mb-0 custom-control-label font-12"
              [innerHTML]=" 'REGISTRATION.ACCEPT_CGU' | translate "></label>
          </div>
          <div *ngIf="isCredFormSubmit && credForm.controls.consent.errors && credForm.controls.consent.errors.required" class="red-error minitext_2">
            {{ "COMMON.CONSENT.ERROR" | translate }}
          </div>
        </div>

        <div class="d-flex gap-8 mt-5">
          <button type="button" class="btn btn-black-border border-2 txt-darkGray" (click)="prevPage()">
            <span class="material-icons va-sub">chevron_left</span>
          </button>
          <button type="submit" id="register_last_page" class="btn btn-primary flex-grow-1 fw-bold py-2 " [disabled]="registerStatus" checkFormError>
            <span *ngIf="registerStatus" class="spinner-border spinner-border-sm me-1 v-middle"></span>
            <span class="material-icons-outlined v-middle font-20 me-1" *ngIf="!registerStatus">file_download_done</span>
            <span *ngIf="!registerStatus">{{ (page === maxPage ? 'REGISTRATION.MODAL_REGISTER.CREATE_ACCOUNT' : 'COMMON.NEXT') | translate }}</span>
            <span *ngIf="registerStatus"> {{ ('REGISTRATION.MODAL_REGISTER.LOADING.' + registerStatus.toUpperCase()) | translate }}</span>
          </button>
        </div>
      </form>
    </div>

<!--   PARTIE INFORMATIONS 2 -->
    <div class="px-5 pb-5 pt-2 w-100" *ngIf="page == maxPage && showInfosForm">

      <div class="mt-3">
        <mat-checkbox [(ngModel)]="hasSchool" (ngModelChange)="getSchool(null)">
          {{ 'REGISTRATION.MODAL_REGISTER.GOT_SCHOOL' | translate  }}
        </mat-checkbox>

        <div class="mt-3" *ngIf="hasSchool">
          <app-accommodation-city-input (hasChangedCity)="getSchool($event)" [searchElement]="infoForm.controls.school_name.value"
                                        placeholder="REGISTRATION.MODAL_REGISTER.WHICH_SCHOOL"
                                        wantBtn="false" type="form-school"></app-accommodation-city-input>
        </div>
      </div>

      <div class="mt-5 w-100 position-relative">
        <span class="label subtitle_1 form-label-color text-black rescale" style="left:-27px;">{{ "REGISTRATION.MODAL_REGISTER.STUDY_CITY" | translate }}</span>
        <app-accommodation-city-input (hasChangedCity)="getCity($event)" [searchElement]="infoForm.controls.city_name.value"
                                      placeholder="COMMON.CITY_NAME"
                                      wantBtn="false" type="form-city"></app-accommodation-city-input>
      </div>

      <!-- duration  -->
      <div class="mt-4">
        <mat-form-field class="w-100 label_wrap" (focusin)="changeDisplayUnit($event)" (focusout)="changeDisplayUnit($event)">
          <mat-label [innerHTML]="'PROFILE.STAY_DURATION' | translate" class="subtitle_1 text-wrap"></mat-label>
          <input matInput type="number" min="1" max="200" [formControl]="infoForm.controls.stayDuration">
          <div class="input_unit" *ngIf="displayUnit || (!displayUnit && infoForm.controls.stayDuration.value)">
            <span class="invisible">{{ infoForm.controls.stayDuration.value }}</span>
            <span class="ms-1">
              {{ (infoForm.controls.stayDuration.value <= 1 ? 'COMMON.MONTH' : 'COMMON.MONTHS')| translate }}
            </span>
          </div>
        </mat-form-field>
      </div>


      <button class="btn btn-primary w-100 mt-5" role="button" type="button" [disabled]="registerStatus === 'updating'"
              (click)="finishLGeneralRegister()">
        {{ "REGISTRATION.MODAL_REGISTER.FINALIZE" | translate }}
        <span *ngIf="registerStatus === 'updating'" class="spinner-border spinner-border-sm me-1 v-middle"></span>
      </button>
    </div>


  </div>

</ng-template>
